/* DeepMoat.ai film player · first click, and captions in a bar under the picture (2026-10-31, film v3.3).
   First click: with preload="none", Chrome ignores a click on the picture until the video has loaded something, so the
   first click would do nothing; while nothing is loaded and the film is paused, a click starts it. After that the
   browser's own controls handle clicks (this does nothing then). Keyboard and the control bar are unchanged.
   Captions:
   Why: at phone width, browsers lift their own captions into the middle of the picture whenever the player's controls show,
   over the film's text (the approval control and open items at 1:10). So while the film plays in the page, the caption
   track stays "hidden" and the current caption is written into the bar under the video. In full screen the bar can't be
   seen, so the browser shows the same track itself. Never two sets of captions at once.
   - The "Captions" button under the film (aria-pressed) switches captions on and off.
   - The player's own captions button still works: choosing captions there shows them the browser's way (over the
     picture) and hides the bar; switching them off there switches them off here too.
   - Nothing here plays the film; it never autoplays.
   Markup (sections/deepmoat-collaborator-blueprint.liquid): <figure data-dm-film> holding the <video>, a
   <script type="text/vtt" data-dm-film-vtt> with the WebVTT text, the bar [data-dm-film-caps] and the button
   [data-dm-film-caps-toggle]. */
(function () {
  'use strict';
  function init(fig) {
    var v = fig.querySelector('video'), src = fig.querySelector('script[data-dm-film-vtt]');
    if (v) v.addEventListener('click', function () {
      if (v.readyState === 0 && v.paused) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
    });
    var bar = fig.querySelector('[data-dm-film-caps]'), btn = fig.querySelector('[data-dm-film-caps-toggle]');
    var state = btn && btn.querySelector('[data-dm-film-caps-state]');
    if (!v || !src || !bar || !v.textTracks || !window.Blob || !window.URL) return;
    var el = document.createElement('track');
    el.kind = 'captions'; el.srclang = 'en'; el.label = 'English';   // not "default": the page decides where captions show
    el.src = URL.createObjectURL(new Blob([src.textContent.replace(/<\\\//g, '</')], { type: 'text/vtt' }));
    v.appendChild(el);
    var track = el.track, pref = 'bar', ours = null;                 // pref: 'bar' (under the picture), 'native', 'off'
    function full() { return document.fullscreenElement === v || document.webkitFullscreenElement === v || !!v.webkitDisplayingFullscreen; }
    function setMode(m) { if (track.mode !== m) { ours = m; track.mode = m; } }
    function render() {
      var s = '', c = track.activeCues;
      if (pref === 'bar' && !full() && c) for (var i = 0; i < c.length; i++) s += (s ? '\n' : '') + c[i].text;
      // the site's Deepmoat AI face draws the em dash hyphen-short, so each dash gets a fallback face (no HTML is parsed)
      bar.textContent = '';
      s.replace(/<[^>]*>/g, '').split('\u2014').forEach(function (part, k) {
        if (k) { var d = document.createElement('span'); d.className = 'dm-bp__film-dash'; d.textContent = '\u2014'; bar.appendChild(d); }
        bar.appendChild(document.createTextNode(part));
      });
    }
    function apply() {
      var fs = full();
      setMode(pref === 'off' ? 'disabled' : (pref === 'native' || fs) ? 'showing' : 'hidden');
      fig.classList.toggle('dm-bp__film--caps-bar', pref === 'bar');
      fig.classList.toggle('dm-bp__film--caps-off', pref === 'off');   // the button stays, so captions can come back
      if (btn) btn.setAttribute('aria-pressed', pref === 'off' ? 'false' : 'true');
      if (state) state.textContent = pref === 'off' ? 'off' : 'on';
      render();
    }
    track.addEventListener('cuechange', render);
    v.textTracks.addEventListener('change', function () {
      if (track.mode === ours) { ours = null; return; }               // our own change
      ours = null;                                                    // the viewer used the player's captions control
      if (full()) pref = track.mode === 'disabled' ? 'off' : (pref === 'off' ? 'bar' : pref);
      else pref = track.mode === 'showing' ? 'native' : track.mode === 'disabled' ? 'off' : 'bar';
      apply();
    });
    if (btn) btn.addEventListener('click', function () { pref = pref === 'off' ? 'bar' : 'off'; apply(); });
    document.addEventListener('fullscreenchange', apply);
    document.addEventListener('webkitfullscreenchange', apply);
    v.addEventListener('webkitbeginfullscreen', function () { setTimeout(apply, 0); });   // iPhone's own full-screen player
    v.addEventListener('webkitendfullscreen', function () { setTimeout(apply, 0); });
    apply();
  }
  function start() { var f = document.querySelectorAll('[data-dm-film]'); for (var i = 0; i < f.length; i++) init(f[i]); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
